import React, { useRef } from 'react';
import { ListItemIcon, Typography } from '@mui/material';
import moment from 'moment';
import { format } from 'date-fns';
import BookItOrCreate from '../bookItOrCreate';
import { useCalendar } from '../calendarContext';
import { colorNameToHex } from '../../../../util/colorMap';

const BookingTypeList = ({ date, showEventDetails, day, month }) => {
    const {
        selectedDate,
        bookingDatas
    } = useCalendar();

    const bookItOrCreateRef = useRef(null);

    // Exit early if there are no bookings
    if (!bookingDatas || bookingDatas.length <= 0) return null;

    // Filter bookings for the specific day
    const dayBookings = bookingDatas.filter((booking) => {
        const bookingDate = moment.utc(booking.time).startOf('day');
        const comparisonDate = moment.utc(date || selectedDate).startOf('day');
        return bookingDate.isSame(comparisonDate, 'day');
    });

    return (
        <div>
            {dayBookings.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px', marginBottom: '2px' }}>
                    {/* Marker for days with events */}
                    {!showEventDetails && (
                        <div
                            style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: 'blue', // Marker color
                                marginTop: '2px',
                            }}
                        />
                    )}

                    {/* List of bookings */}
                    <Typography fontSize="10px" style={{ textAlign: 'left', margin: '30px 2px 0 2px', }}>
                        {dayBookings.map((booking, index) => {
                            const bookingDate = new Date(booking.time);

                            return (
                                <div
                                    key={index}
                                    onClick={() => bookItOrCreateRef.current('update', booking, day, month)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center', 
                                        cursor: 'pointer',
                                        textAlign: 'left',
                                        width: '100%',
                                    }}
                                >
                                    {showEventDetails && (
                                        <div
                                        style={{
                                                fontWeight: 500,
                                                fontSize: '0.59rem',
                                                fontFamily: '"Inter", "Noto Sans", "Segoe UI", "Roboto", sans-serif',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                lineHeight: 1.4,
                                                color: colorNameToHex.DarkBlue,
                                            }}
                                        >
                                            {/* <span style={{ fontWeight: 700, marginRight: '4px' }}>
                                                {format(bookingDate, "h:mm a").toLowerCase()}
                                            </span>
                                            <span style={{ marginRight: '4px' }}>-</span> */}

                                            <span style={{ flex: 1, color: booking?.color }}>
                                                <span style={{ fontSize: '0.59rem' }}>[{booking.icon}]</span> {booking.title}
                                            </span>
                                        </div>

                                    )}
                                </div>
                            );
                        })}
                    </Typography>
                </div>
            )}

            {/* Indicate additional bookings
            {dayBookings.length > 2 && showEventDetails && (
                <Typography fontSize="14px" style={{ marginTop: '1px' }}>
                    more ...
                </Typography>
            )} */}

            {/* Dialog handler */}
            {/* <BookItOrCreate triggerDialog={(handler) => (bookItOrCreateRef.current = handler)} /> */}
        </div>
    );
};

export default BookingTypeList;
